export const OPEN_ORDERS = 'navigation/OPEN_ORDERS';
export const CHECKOUT = 'navigation/CHECKOUT';
export const OPEN_ORDER = 'navigation/OPEN_ORDER';
